import React from 'react';
import { Error } from './Error';
import DIContainer from '../../../config/di.container';
import DITypes from '../../../config/di.types';
import GlobalErrorHandlerService from '../../../services/GlobalErrorHandlerService';

const errorHandlingService : GlobalErrorHandlerService = DIContainer.get<GlobalErrorHandlerService>(DITypes.GlobalErrorHandlerService);

interface IState{
    hasError: boolean,
    error: any,
    errorInfo: any
}

class ErrorBoundary extends React.Component<{},IState> {
    constructor(props) {
      super(props);
      this.state = { 
        hasError: false, 
        error: null, 
        errorInfo: null 
      };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        });
        errorHandlingService.handleError(error,null);
    }
  
    render() {
      if (this.state.hasError) {
        return <Error error={this.state.error} errorInfo={this.state.errorInfo} />
      }
  
      return this.props.children; 
    }
}

export default ErrorBoundary;